import React from 'react';
import { OverlayWrapper, ExportedOverlayProps, Tooltip, TooltipProps, TooltipValueProps } from 'spindl-shared-components';
import InternalErrorIndicator from './ErrorIndicator';
import { ErrorIndicatorProps, ErrorIndicatorValueProps as InternalErrorIndicatorValueProps } from './types';

export type { ErrorIndicatorProps }; // MANUAL OVERRIDE

// MANUAL OVERRIDE
export type ErrorIndicatorValueProps = ExportedOverlayProps<
TooltipValueProps & TooltipProps,
InternalErrorIndicatorValueProps
>;

// MANUAL OVERRIDE
const ErrorIndicator: React.FC<ErrorIndicatorValueProps> = (props) => (
  <OverlayWrapper
    {...props}
    Content={Tooltip}
    Target={InternalErrorIndicator}
  />
);

export default ErrorIndicator;
